import { startGlobalNav } from '@avvo/ui-html-components/global-nav'
startGlobalNav({
  envVars: window.config.envVars,
  myMADashboardUrl: window.config.myMADashboardURL,
})
